const NBG_API = 'https://nbg.gov.ge/gw/api/ct/monetarypolicy/currencies/en/json/';
const CACHE_KEY = 'gallery-nbg-rate';
const CACHE_DURATION = 60 * 60 * 1000; // 1 hour

interface CachedRate {
  rate: number;
  timestamp: number;
}

function getCachedRate(): number | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { rate, timestamp } = JSON.parse(raw) as CachedRate;
    if (Date.now() - timestamp > CACHE_DURATION) return null;
    return rate;
  } catch {
    return null;
  }
}

function setCachedRate(rate: number): void {
  localStorage.setItem(CACHE_KEY, JSON.stringify({ rate, timestamp: Date.now() }));
}

// Default fallback if API unavailable
const FALLBACK_RATE = 2.67;

let currentRate: number = getCachedRate() || FALLBACK_RATE;

export function getExchangeRate(): number {
  return currentRate;
}

export async function fetchExchangeRate(): Promise<number> {
  const cached = getCachedRate();
  if (cached) {
    currentRate = cached;
    return cached;
  }

  try {
    const res = await fetch(NBG_API);
    if (!res.ok) return currentRate;
    const data = await res.json();
    const currencies = data?.[0]?.currencies;
    if (!Array.isArray(currencies)) return currentRate;
    const usd = currencies.find(
      (c: { code: string; rate: number }) => c.code === 'USD',
    );
    if (usd?.rate && typeof usd.rate === 'number') {
      currentRate = usd.rate;
      setCachedRate(usd.rate);
      return usd.rate;
    }
  } catch {
    // Silently fail — use cached or fallback rate
  }

  return currentRate;
}
